import { ContainerHeader } from 'shared/ui/Header'
import { EmptyState } from 'shared/ui/EmptyState/EmptyState'
import { Chat2 } from 'shared/assets/icons'
import { ConversationSendMessage } from 'widgets/inbox/ConversationSendMessage'

export const NewConversationChatUi = () => {
  return (
    <>
      <ContainerHeader>
        <div>Header</div>
      </ContainerHeader>
      <EmptyState
        title={'No conversation yet'}
        description={'Send a message.'}
        IconFC={Chat2}
        variant={'secondary'}
      />
      <ConversationSendMessage />
    </>
  )
}
